import { Icon } from "@material-ui/core"
import lon from './logos/ouon.png'
                                       
export const Iconou2 = () => (
    <Icon>
        <img src={lon} />
    </Icon>
)